export default {
  /**
   *
   * @param {String} original
   * @returns {String}
   * @description
   * 굽은 인용 문자가 제거된 문자열을 리턴
   *
   */
  replaceSmartQuotes(original) {
    return original.replace(/[\u2018\u2019]/g, "'").replace(/[\u201C\u201D]/g, '"');
  },
};
